export default __webpack_public_path__ + "static/media/handAvatar.6bfb6a7a.png";